<div
  data-id="advanced-filter-relationship"
  *transloco="let t; scope: 'featureSearch'"
  class="flex items-center bd-advanced-filter-relationship"
>
  <bd-dropdown
    data-id="relationship-filter-condition-dropdown"
    [options]="conditionOptions()"
    [settings]="conditionDropdownSettings"
    [(ngModel)]="selectedCondition"
    (selectNode)="onConditionChange($event)"
    (unselectNode)="onConditionChange()"
  />
  <p-divider
    class="bd-advanced-filter-divider bd-small"
    [ngClass]="{
      'bd-advanced-filter-divider-disabled': !selectedCondition(),
    }"
  />

  <bd-dropdown
    data-id="relationship-filter-relation-dropdown"
    [options]="relationOptions()"
    [settings]="relationDropdownSettings"
    [(ngModel)]="selectedRelation"
    [state]="selectedCondition() ? 'default' : 'disabled'"
    (selectNode)="onRelationChange($event)"
    (unselectNode)="onRelationChange()"
    [autoFocus]="autoFocusRelationDropdown()"
  />
  <p-divider
    class="bd-advanced-filter-divider bd-small"
    [ngClass]="{
      'bd-advanced-filter-divider-disabled': !selectedRelation(),
    }"
  />
  <bd-dropdown
    data-id="relationship-filter-target-dropdown"
    [options]="targetOptions()"
    [settings]="targetDropdownSettings"
    [(ngModel)]="selectedTarget"
    [state]="selectedRelation() ? 'default' : 'disabled'"
    (selectNode)="onTargetChange($event)"
    (unselectNode)="onTargetChange()"
    [autoFocus]="autoFocusTargetDropdown()"
  />
  <p-divider
    class="bd-advanced-filter-divider bd-small"
    [ngClass]="{
      'bd-advanced-filter-divider-disabled': objectSelectionDisabled(),
    }"
  />
  @if (selectedTarget()?.key === 'specificObject') {
    <div class="flex flex-col flex-1 gap-2">
      <label
        class="bd-label-small-gray"
        for="object-autocomplete"
        [ngClass]="{
          disabled: objectSelectionDisabled(),
        }"
        >{{
          t('featureSearch.relationshipFilter.objectAutocompleteLabel')
        }}</label
      >
      <bd-object-autocomplete
        id="object-autocomplete"
        [disabled]="objectSelectionDisabled()"
        [editMode]="true"
        (searchTermReseted)="submitSelectedObject()"
        (searchTermChanged)="searchObjects($event)"
        (submitObject)="submitSelectedObject($event)"
        [selectedObject]="selectedObject()?.name ?? ''"
        [searchSuggestions]="
          store.objectSearchStoreProperties().searchSuggestions
        "
        [searchSuggestionsLoading]="
          store.objectSearchStoreProperties().searchSuggestionsLoading
        "
        [placeholder]="
          t('featureSearch.relationshipFilter.objectAutocompletePlaceholder')
        "
        [emptyStateMessage]="
          t('featureSearch.relationshipFilter.objectAutocompleteEmptyMessage')
        "
        [autoFocus]="autoFocusObjectAutocomplete()"
      ></bd-object-autocomplete>
    </div>
  } @else {
    <bd-dropdown
      data-id="relationship-filter-object-type-dropdown"
      [options]="objectTypeOptions()"
      [settings]="objectTypeDropdownSettings()"
      [(ngModel)]="selectedObjectType"
      [state]="objectSelectionDisabled() ? 'disabled' : 'default'"
      (selectNode)="onObjectTypeChange($event)"
      (unselectNode)="onObjectTypeChange()"
      [autoFocus]="autoFocusObjectTypeDropdown()"
    />
  }
  <p-button
    [attr.aria-label]="t('featureSearch.relationshipFilter.removeBtnInfo')"
    styleClass="bd-danger"
    data-id="relationship-filter-remove-btn"
    (onClick)="removeFilter()"
    [pTooltip]="t('featureSearch.relationshipFilter.removeBtnInfo')"
    tooltipPosition="top"
    icon="ui-delete"
    [outlined]="true"
    class="self-end ml-[12px]"
    [disabled]="!selectedCondition()"
  >
  </p-button>
</div>
